"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var navStackStateKey = "navStack";
var getNavStack = function (host) {
    return host.getState(navStackStateKey);
};
exports.getNavStack = getNavStack;
var pushAndLoad = function (host, request) {
    var navStack = host.getState(navStackStateKey, function () {
        return [];
    });
    navStack.push({ path: host.path, title: host.title });
    host.load(request);
};
exports.pushAndLoad = pushAndLoad;
var popAndLoad = function (host, fallbackRequest) {
    var navStack = host.getState(navStackStateKey);
    if (navStack && navStack.length > 0) {
        host.load(navStack.pop());
    }
    else {
        host.load(fallbackRequest);
    }
};
exports.popAndLoad = popAndLoad;
